import { ReactNode } from "react"
import { useFlags } from "./FeatureFlagProvider"
import { FeatureFlagName } from "./featureFlags"

export function FeatureGate({ flag, children }: { flag: FeatureFlagName; children: ReactNode }) {
  const { isEnabled } = useFlags()
  return isEnabled(flag) ? <>{children}</> : null
}
